import React from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import Footer from "../Component/Footer";
import { useEffect } from "react";
const SchoolFees = () => {
  useEffect(() => {
    // Set the page title
    document.title = "School Fees - Presentation Convent School Delhi";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Admission </li>
          <li>School Fees</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>School Fees</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <ul className="innerlist">
                <li>
                  School fees is charged quarterly for{" "}
                  <strong>
                    April-June, July-September, October-December and
                    January-March
                  </strong>
                  . It is payable within the first fifteen days from the date
                  the fee slip is sent to the class, which is usually the first
                  working day of each quarter.
                </li>
                <li>School fees is accepted by way of cheque only.</li>
                <li>
                  The cheque should be payable to Presentation Convent Sr. Sec.
                  School. Write on the back of the cheque: Name of the student,
                  Fee Slip No., Class &amp; Section.
                </li>
                <li>Outstation cheques are not accepted.</li>
                <li>
                  During this period, a "Drop Box" will be kept within the
                  school premises. Cheques must be dropped in the "Drop Box"
                  only.
                </li>
                <li>
                  After the last date, as indicated above, the fee will be
                  accepted only at Union Bank of India, S.B. Sarafa Market,
                  during banking hours. A late fee of Rs. 100/- will be charged
                  for first 15 days, an additional amount of Rs. 200/- per month
                  will be charged till the fee has been paid.
                </li>
                <li>
                  If the cheque is returned/dishonored on account of
                  insufficient funds/post dated/any other, the payment of the
                  same will be accepted in School only by way of Pay Order along
                  with a fine Rs. 500/-
                </li>
                <li>
                  A fine of Rs. 25/- will be charged for issuing a duplicate fee
                  slip.
                </li>
                <li>
                  Students should clear all dues before the examinations.
                  Otherwise they will not be allowed to sit for the examination.
                </li>
                <li>
                  Parents have the option to pay the fee in advance for the
                  whole year. A rebate of Rs. 500/- will be given to those who
                  pay the full fee in April.
                </li>
              </ul>
              <br />
              {/* <div className="table-responsive maintable">
                         
                      <table className="table">
                          <thead>            
                              <tr>
                                  <th>Class</th>
                                  <th>Tution Fees (Monthly)</th>
                                  <th>Annual Fees</th> 
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>KG-V</td>
                                  <td>5,100.00</td>
                                  <td>9,000.00</td> 
                              </tr>
                              <tr>
                                  <td>VI-X</td>
                                  <td>5,590.00</td>
                                  <td>11,400.00</td> 
                              </tr>
                              <tr>
                                  <td>XI-XII</td>
                                  <td>5,890.00</td>
                                  <td>11,400.00</td> 
                              </tr>
                              </tbody>
                      </table>
                      </div> */}
              <div class="table-responsive maintable">
                <table class="table table-bordered table-striped align-middle text-center">
                  <thead class="table-light">
                    <tr>
                      <th colspan="3" class="fw-bold fs-4">
                        Academic Year 2026-2027
                      </th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>MONTHLY</th>
                      <th>YEARLY</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr class="table-secondary fw-bold">
                      <td colspan="3" class="text-start">
                        NURSARY - V
                      </td>
                    </tr>
                    <tr>
                      <td class="text-start">Tuition Fees</td>
                      <td>5,100</td>
                      <td>61,200</td>
                    </tr>
                    <tr>
                      <td class="text-start">Annual Fees</td>
                      <td>750</td>
                      <td>9,000</td>
                    </tr>
                    <tr class="fw-bold">
                      <td class="text-start">TOTAL</td>
                      <td>5,850</td>
                      <td>70,200</td>
                    </tr>

                    <tr class="table-secondary fw-bold">
                      <td colspan="3" class="text-start">
                        VI - X
                      </td>
                    </tr>
                    <tr>
                      <td class="text-start">Tuition Fees</td>
                      <td>5,590</td>
                      <td>67,080</td>
                    </tr>
                    <tr>
                      <td class="text-start">Annual Fees</td>
                      <td>950</td>
                      <td>11,400</td>
                    </tr>
                    <tr class="fw-bold">
                      <td class="text-start">TOTAL</td>
                      <td>6,540</td>
                      <td>78,480</td>
                    </tr>

                    <tr class="table-secondary fw-bold">
                      <td colspan="3" class="text-start">
                        XI - XII
                      </td>
                    </tr>
                    <tr>
                      <td class="text-start">Tuition Fees</td>
                      <td>5,890</td>
                      <td>70,680</td>
                    </tr>
                    <tr>
                      <td class="text-start">Annual Fees</td>
                      <td>950</td>
                      <td>11,400</td>
                    </tr>
                    <tr class="fw-bold">
                      <td class="text-start">TOTAL</td>
                      <td>6,840</td>
                      <td>82,080</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SchoolFees;
